angular.module('inspinia').factory('videoService', function (facilityService) {
  const state = {
    // 動画配信の申込フォームリンクを表示しない施設一覧
    // 自治体一覧にもなるが、完全に自治体一覧と一致しているわけではない。あくまで動画配信の申込みフォームリンクを表示しない自治体施設一覧
    videoOptionBannerBlackList: [
      '107',
      '2072',
      '5017',
      '4827',
      '5325',
      '5771',
      '7373',
      '7641',
      '7920',
      '10231',
      '8698',
      '8778',
      '8855',
      '8896',
      '8933',
      '9288',
      '9334',
      '9372',
      '9416',
      '9729',
      '9919',
      '10121',
      '10147',
      '10217',
      '10231',
      '10255',
      '10373',
      '10471',
      '10628',
      '10667',
      '10686',
      '10813',
      '11250',
      '11299',
      '11339',
      '11376',
      '11405',
      '11414',
      '11478',
      '12440',
      '11725',
      '11726',
      '11752',
      '11779',
      '11813',
      '14694',
      '11891',
      '12063',
      '12106',
      '12168',
      '12170',
      '12201',
      '12207',
      '7920',
      '12254',
      '12382',
      '12440',
      '12479',
      '12551',
      '12589',
      '12663',
      '12708',
      '12723',
      '12784',
      '12844',
      '12869',
      '11813',
      '12919',
      '12952',
      '12971',
      '13032',
      '13116',
      '13128',
      '13248',
      '13268',
      '13346',
      '13362',
      '13421',
      '13520',
      '13555',
      '13633',
      '13655',
      '13708',
      '13807',
      '13867',
      '13869',
      '13898',
      '14051',
      '14068',
      '14200',
      '14212',
      '14227',
      '14280',
      '14281',
      '14282',
      '14371',
      '14442',
      '14553',
      '14570',
      '14573',
      '14583',
      '14613',
      '14648',
      '14690',
      '14694',
      '14750',
    ],
  };

  /**
   * 重複を判定
   * @param {array}
   * @param {array}
   * @return {boolean}
   */
  function getIsDuplicate(arr1, arr2) {
    if (!arr1 || !arr2) return false;
    return (
      arr1.concat(arr2).filter(function (item) {
        return arr1.indexOf(item) >= 0 && arr2.indexOf(item) >= 0;
      }).length > 0
    );
  }

  // Getters

  /**
   * 再販代理店経由の施設 または 自身を含む兄弟施設がブラックリストに入っていない施設
   * @returns {boolean}
   */
  const getIsVideoOptionDisplayTargetFacility = () => {
    // 自身を含む兄弟施設がブラックリストに入っている（自治体）
    const hasGroupServiceId = getIsDuplicate(facilityService.getGroupServiceIds(), state.videoOptionBannerBlackList);

    // 再販代理店経由の施設
    const isViaResaleAgencyFacility = facilityService.getIsViaResaleAgencyFacility();
    return isViaResaleAgencyFacility || hasGroupServiceId;
  };

  return {
    getIsVideoOptionDisplayTargetFacility,
  };
});
